import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function addLayoutItem(data) {
  return request({
    url: `${v2Host}/ps/layout/asset/create`,
    method: 'post',
    data,
  })
}

export function updateLayoutItem(data) {
  return request({
    url: `${v2Host}/ps/layout/asset/update`,
    method: 'post',
    data,
  })
}

export function deleteLayoutItem(data) {
  return request({
    url: `${v2Host}/ps/layout/asset/delete?id=${data.id}`,
    method: 'post',
    data,
  })
}

export function fetchLayoutList(params) {
  return request({
    url: `${v2Host}/ps/layout/asset/list`,
    method: 'get',
    params,
  })
}
